import * as React from 'react';
const h = React.createElement;

export interface StatisticProps {
  title?: React.ReactNode;
  value?: React.ReactNode;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  valueStyle?: React.CSSProperties;
  className?: string;
}

const Statistic: React.FC<StatisticProps> = function Statistic(props) {
  const { title, value, prefix, suffix, valueStyle, className = '' } = props;
  return h(
    'div',
    { className },
    title && h('div', { className: 'text-sm text-dark-400 mb-1' }, title),
    h(
      'div',
      { className: 'flex items-baseline gap-1', style: valueStyle },
      prefix && h('span', { className: 'text-lg' }, prefix),
      h('span', { className: 'text-2xl font-bold' }, value),
      suffix && h('span', { className: 'text-sm' }, suffix),
    ),
  );
};

export { Statistic };
